import React, { Component, useState, useEffect, useMemo, useRef } from 'react';
import {
  RecoilRoot,
  atom,
  selector,
  useRecoilState,
  useRecoilValue,
  useSetRecoilState,
} from 'recoil';

import loadable from "@loadable/component";

import {
  BrowserRouter,
  Routes,
  createBrowserRouter,
  RouterProvider,
  Route,
  Navigate,
  useNavigate,
  useLocation,
  Link
} from 'react-router-dom';
import { connect } from 'react-redux';
import { withTranslation, Translation, } from 'react-i18next';

import {BrowserView,MobileView,TabletView, isMobileOnly, isTablet} from 'react-device-detect';

import { isLoggedin, userState, authState } from "./store/stateData";

import { isLogin } from './utils';

import i18n from "./i18n";

import {generateIPForREST} from "./actions";

import setLanguage from "./actions/setLanguage";


import LoadingPage from "./components/pages/home/LoadingPage";

import Header from "./components/header/Header";
import Footer from "./components/footer/Footer";


//const algoliasearch = require('algoliasearch');
//var client = algoliasearch('HKB157K3KU', '357f2b37e5ef8c12f7b90877758ff663');


const viewportWidth = window.innerWidth;
const viewportHeight = window.innerHeight;


const HomePage = loadable(() => import("./components/pages/home/HomePage"), {
   fallback: <LoadingPage />
});

const HomeinPage = loadable(() => import("./components/pages/home/HomeinPage"), {
   fallback: <LoadingPage />
});

const PreviewPage = loadable(() => import("./components/pages/home/PreviewPage"), {
   fallback: <LoadingPage />
});
const UserPage = loadable(() => import("./components/pages/home/UserPage"), {
   fallback: <LoadingPage />
});
const InstructorPage = loadable(() => import("./components/pages/home/InstructorPage"), {
   fallback: <LoadingPage />
});
const SchoolPage = loadable(() => import("./components/pages/home/SchoolPage"), {
   fallback: <LoadingPage />
});
const SchoolCoursesPage = loadable(() => import("./components/pages/home/SchoolCoursesPage"), {
   fallback: <LoadingPage />
});
const SchoolInstructorsPage = loadable(() => import("./components/pages/home/SchoolInstructorsPage"), {
   fallback: <LoadingPage />
});
const CheckoutPage = loadable(() => import("./components/pages/home/CheckoutPage"), {
   fallback: <LoadingPage />
});
const CartPage = loadable(() => import("./components/pages/home/CartPage"), {
   fallback: <LoadingPage />
});
const CoursePage = loadable(() => import("./components/pages/home/CoursePage"), {
   fallback: <LoadingPage />
});


const MyaccountPage = loadable(() => import("./components/pages/home/MyaccountPage"), {
   fallback: <LoadingPage />
});
const SaveditemsPage = loadable(() => import("./components/pages/home/SaveditemsPage"), {
   fallback: <LoadingPage />
});
const MycoursesPage = loadable(() => import("./components/pages/home/MycoursesPage"), {
   fallback: <LoadingPage />
});
const PaymentsPage = loadable(() => import("./components/pages/home/PaymentsPage"), {
   fallback: <LoadingPage />
});

const PaymentHistoryPage = loadable(() => import("./components/pages/home/PaymentHistoryPage"), {
   fallback: <LoadingPage />
});


const SigninPage = loadable(() => import("./components/pages/auth/SigninPage"), {
   fallback: <LoadingPage />
});
const SignupPage = loadable(() => import("./components/pages/auth/SignupPage"), {
   fallback: <LoadingPage />
});
const ForgotPswdPage = loadable(() => import("./components/pages/auth/ForgotPswdPage"), {
   fallback: <LoadingPage />
});
const NewPswdPage = loadable(() => import("./components/pages/auth/NewPswdPage"), {
   fallback: <LoadingPage />
});
const CodePswdPage = loadable(() => import("./components/pages/auth/CodePswdPage"), {
   fallback: <LoadingPage />
});





const SupportPage = loadable(() => import("./components/pages/general/SupportPage"), {
       fallback: <LoadingPage />
});

const TermsPage = loadable(() => import("./components/pages/general/TermsPage"), {
       fallback: <LoadingPage />
});

const PrivacyPage = loadable(() => import("./components/pages/general/PrivacyPage"), {
       fallback: <LoadingPage />
});

const HelpPage = loadable(() => import("./components/pages/general/HelpPage"), {
       fallback: <LoadingPage />
});

const HelpinPage = loadable(() => import("./components/pages/general/HelpinPage"), {
       fallback: <LoadingPage />
});



const AssetsPage = loadable(() => import("./components/pages/home/AssetsPage"), {
   fallback: <LoadingPage />
});

const NoMatch = loadable(() => import("./components/pages/home/NoMatch"), {
   fallback: <LoadingPage />
});


const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <HomePage/>
    ),
  },
  {
    path: "about",
    element: <div>About</div>,
  },
]);

/*
<RouterProvider router={router} />
*/

const ProtectedRoute = ({ isSignedin, children }) => {

  const location = useLocation();
  const pathWithoutSlash = location.pathname.startsWith('/')
    ? location.pathname.slice(1)
    : location.pathname;

  localStorage.setItem("yeqolaAfter", `${pathWithoutSlash}`);

  if (!isSignedin) {
    return <Navigate to={`/signin?after=${pathWithoutSlash}`} replace />;
  }

  return children;
};

const PublicRoute = ({ isSignedin, children }) => {

   //alert(`>> >> ` + isLogin())

  //sSignedin={isLogin()}

  if (isLogin()) {
    return <Navigate to="/home" replace />;
  }

  return children;
};

global.myCountryCode = 'CD';
global.headerBool = false;
global.closeBtnClicked = false;

const App = () => {


    const [isSignedin, setIsSignedin] = useRecoilState(isLoggedin);
    const [sinUser, setSinUser] = useRecoilState(userState);
    const sinUserRef = useRef(sinUser);

  //  console.log('>> isLoggedin >> ' + JSON.stringify(isLoggedin));
  //  console.log('>> isSignedin >> ' + isSignedin);
    //alert('>> sinUser >> ' + JSON.stringify(isLogin()));






      useEffect(() => {



          window.onorientationchange = (event) => {
            if (isMobileOnly || isTablet)
            {
               window.location.reload();
            }
          };




          fetch('https://api.ipstack.com/check?access_key=9cd4ffbf45a257de9e644d4d875a9465')
           		  	.then((response) => response.json())
           		  	.then((responseData) => {
           			  	      //alert("App. Store: " + JSON.stringify(responseData));

                             global.country = responseData.country_code;
                             global.continent = responseData.continent_code;
                             global.ip = responseData.ip;


                             global.myCountryCode = responseData.country_code;

                             localStorage.setItem("geoLocation", responseData);

                    				  if (isLogin())
                    				  {

                          					  if (localStorage.getItem('language') === null)
                          					  {
                          						  getLanguageFromServer(responseData.country_code);


                          					  }
                          					  else
                          					  {
                          						  var _lang = localStorage.getItem('language');
                          						 // console.log("Got language from localStore: " + _lang);
                          					  	  i18n.changeLanguage(_lang);
                          					  }

                    				  }
                    				  else
                    				  {

                                       //alert(responseData.country_code)

                                       //this.props.setLanguage('US');

                                       if (localStorage.getItem('language') === null)
                           					  {
                           						  setLanguage(responseData.country_code);


                           					  }
                           					  else
                           					  {
                           						  var _lang = localStorage.getItem('language');
                           						 // console.log("Got language from localStore: " + _lang);
                           					  	  i18n.changeLanguage(_lang);
                           					  }


                    				  }

           		      })
           		     .catch(function(error) {

           		     });



      }, []);



      const getLanguageFromServer = (_country_code) => {
       //var ip = "https://www.debyoo.com/";
       var ip = generateIPForREST();

       var jwtToken = localStorage.getItem("jwtToken") || '';
       //  this.props.setLanguage(responseData.country_code);
       fetch(ip+'get_language_from_server_api', {
                  method: 'POST',
                  headers: {
                    'Accept': 'application/json',
                    'Authorization': jwtToken,
                    'Content-Type': 'application/json'
                  },
                  credentials: 'include',
                  body: JSON.stringify({
                  })
            })
           .then((response) => response.json())
           .then((responseData) => {
              //console.log("Got language from server: " + responseData.language);
              i18n.changeLanguage(responseData.language);
            })
            .catch(function(error) {
                setLanguage(_country_code);
            }.bind(this));
     }



    //console.log('>> ---- sinUser >> ' + JSON.stringify(_authStatus));

       return (
         <Translation>
           {
               t =>
              <RecoilRoot>
               <BrowserRouter>

                 <Header isSignedin={isLogin()} sinUser={sinUser}/>

                 <Routes>
                   <Route path="/" element={<PublicRoute isSignedin={false}><HomePage /></PublicRoute>} />
                   <Route path="/support" element={<SupportPage isSignedin={isLogin()} sinUser={isLogin() ? sinUser:null}/>} />
                   <Route path="/terms" element={<TermsPage isSignedin={isLogin()} sinUser={isLogin() ? sinUser:null}/>} />
                   <Route path="/privacy" element={<PrivacyPage isSignedin={isLogin()} sinUser={isLogin() ? sinUser:null}/>} />
                   <Route path="/help" element={<HelpPage isSignedin={isLogin()} sinUser={isLogin() ? sinUser:null}/>} />
                   <Route path="/help/:id" element={<HelpinPage isSignedin={isLogin()} sinUser={isLogin() ? sinUser:null}/>} />
                   <Route path="/preview/:id" element={<PreviewPage isSignedin={isLogin()} sinUser={sinUser}/>} />
                   <Route path="/instructor/:id" element={<InstructorPage isSignedin={isLogin()} sinUser={sinUser}/>} />
                   <Route path="/school/:id" element={<SchoolPage isSignedin={isLogin()} sinUser={sinUser}/>} />
                   <Route path="/user/:id" element={<UserPage isSignedin={isLogin()} sinUser={sinUser}/>} />
                   <Route path="/school/:id/instructors" element={<SchoolInstructorsPage isSignedin={isLogin()} sinUser={sinUser}/>} />
                   <Route path="/school/:id/courses" element={<SchoolCoursesPage isSignedin={isLogin()} sinUser={sinUser}/>} />
                   <Route path="/checkout" element={<CheckoutPage isSignedin={isLogin()} sinUser={sinUser}/>} />
                   <Route path="/cart" element={<CartPage isSignedin={isLogin()} sinUser={sinUser}/>} />
                   <Route path="/signin" element={<SigninPage isSignedin={isLogin()} />} />
                   <Route path="/signup" element={<SignupPage isSignedin={isLogin()} />} />
                   <Route path="/resetpswd" element={<ForgotPswdPage isSignedin={isLogin()} />} />
                   <Route path="/home" element={<ProtectedRoute isSignedin={isLogin()}><HomeinPage sinUser={sinUser}/></ProtectedRoute>} />
                   <Route path="/course/:id" element={<ProtectedRoute isSignedin={isLogin()}><CoursePage sinUser={sinUser}/></ProtectedRoute>} />
                   <Route path="/myaccount" element={<ProtectedRoute isSignedin={isLogin()}><MyaccountPage sinUser={sinUser}/></ProtectedRoute>} />
                   <Route path="/saveditems" element={<ProtectedRoute isSignedin={isLogin()}><SaveditemsPage sinUser={sinUser}/></ProtectedRoute>} />
                   <Route path="/mycourses" element={<ProtectedRoute isSignedin={isLogin()}><MycoursesPage sinUser={sinUser}/></ProtectedRoute>} />
                   <Route path="/payments" element={<ProtectedRoute isSignedin={isLogin()}><PaymentsPage sinUser={sinUser}/></ProtectedRoute>} />
                   <Route path="/payments/history" element={<ProtectedRoute isSignedin={isLogin()}><PaymentHistoryPage sinUser={sinUser}/></ProtectedRoute>} />
                   <Route path="/assets" element={<PublicRoute isSignedin={false}><AssetsPage /></PublicRoute>} />
                   <Route path="*" element={<NoMatch />} />
                 </Routes>

                 <Footer/>

               </BrowserRouter>



             </RecoilRoot>
            }
        </Translation>
      );

}

const mapStateToProps = state => ({
  ...state
});

const mapDispatchToProps = dispatch => ({
 setLanguage:  (payload) => dispatch(setLanguage(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
